<md-tag class="status-40x">
	<span>403 Error</span>
</md-tag>

<div class="message-40x">
	<div class="md-display-lg-semibold">Access Denied...</div>
	<div class="md-text-md-regular">Sorry! You do not have permission to view this page.</div>
</div>

@if (isImpersonating()) {
	<div class="message-40x">
		<div class="md-text-md-regular">
			You are acting as another user. If this page is refused because that person may not see it, stop acting as them and try again.
		</div>
	</div>
}

<div class="actions-40x">
	<a href="#" onclick="history.back(); return false;" md-button>Go Back</a>
	@if (isImpersonating()) {
		<button type="button" md-button-brand (click)="endImpersonation()">End Impersonation</button>
	}
	<a href="/" md-button-brand>Go Home</a>
</div>
